import { useEffect, useRef } from "react";
export const useOnUnmount = (callback) => {
    const callbackRef = useRef(callback);
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    useEffect(() => {
        return () => {
            callbackRef.current();
        };
    }, []);
};
//# sourceMappingURL=useOnUnmount.js.map